module.exports = __webpack_public_path__ + "static/media/see-your-thoughts.38006996.png";